<mat-select [value]="displayFontName"
  (selectionChange)="setFontName($event.value)"
  [ngStyle]="selectedFontStyle"
            placeholder="{{ 'i18n.control.fontChooser.placeholderText' |
                            translate }}"
  >
  @for (font of availableFonts; track font) {
    <mat-option
      [value]="font"
      [ngStyle]="fontPreviewBackground(font)"
      >
      <span class="hidden">{{font}}</span>
    </mat-option>
  }
</mat-select>
